// Convierte el objeto tema del contrato de datos en variables CSS con el
// prefijo de cada plantilla: colores.fondoAlt -> --{prefijo}-fondo-alt, etc.
export function construirEstiloTema(tema, prefijo) {
  const estilo = {};
  Object.entries(tema?.colores || {}).forEach(([clave, valor]) => {
    const sufijo = clave.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());
    estilo[`--${prefijo}-${sufijo}`] = valor;
  });
  const fuentes = tema?.fuentes || {};
  if (fuentes.display) estilo[`--${prefijo}-fuente-display`] = fuentes.display;
  if (fuentes.cuerpo) estilo[`--${prefijo}-fuente-cuerpo`] = fuentes.cuerpo;
  return estilo;
}
